/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditScheduleAuditSchedulesListQueryResponse, AuditScheduleAuditSchedulesListQueryParams } from "../models/AuditScheduleAuditSchedulesList";

export function getAuditScheduleAuditSchedulesListUrl() {
  const res = { method: 'GET', url: `/audit-schedule/v1/schedules` as const }
  return res
}

/**
 * @description Returns paginated schedules using the mi-api CRUD list contract. Filterable fields: `customId`, `datetime`, `tolerance`, `type`, `advertiser`, `campaign`, `version`, and nested `custom.*`.
 * @summary List schedules
 * {@link /audit-schedule/v1/schedules}
 */
export async function auditScheduleAuditSchedulesList(params: AuditScheduleAuditSchedulesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditScheduleAuditSchedulesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditScheduleAuditSchedulesListUrl().url.toString(), params, ... requestConfig })
  return res.data
}